var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophy1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140.469,
    height: 215,
    viewBox: "0 0 140.469 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trophy_7_",
    "data-name": "trophy (7)",
    transform: "translate(-88.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48969",
    "data-name": "Path 48969",
    d: "M224.7,288.114V254.158H196.34v34.3c0,34.088-23.382,39.52-23.382,39.52h74.113S224.7,323.521,224.7,288.114Z",
    transform: "translate(-51.036 -150.624)",
    fill: "#ffb139"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48970",
    "data-name": "Path 48970",
    d: "M256,254.157v73.818h37.057s-22.369-4.455-22.369-39.863V254.157H256Z",
    transform: "translate(-98.474 -150.623)",
    fill: "#ff7e4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48971",
    "data-name": "Path 48971",
    d: "M138.827,100.016a4.756,4.756,0,0,1-2.122.812l-43.77,5.354a4.763,4.763,0,0,0-2.668,8.212l32.264,30.06a4.751,4.751,0,0,1,1.327,2.185l53.767-15.317Z",
    transform: "translate(0 -58.692)",
    fill: "#ffdd27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48972",
    "data-name": "Path 48972",
    d: "M236.113,125.81l8.874,63.688a4.764,4.764,0,0,1,2.311.6l38.558,21.4a4.763,4.763,0,0,0,6.986-5.075l-8.433-43.283a4.754,4.754,0,0,1,.1-2.211Z",
    transform: "translate(-87.869 -74.989)",
    fill: "#ffdd27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48973",
    "data-name": "Path 48973",
    d: "M295.514,146.639a4.751,4.751,0,0,1,1.327-2.185l32.264-30.06a4.763,4.763,0,0,0-2.668-8.212l-43.77-5.354a4.753,4.753,0,0,1-2.122-.812l-24.559,31.316Z",
    transform: "translate(-101.414 -58.692)",
    fill: "#ffb139"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48974",
    "data-name": "Path 48974",
    d: "M250.085,44.631a4.752,4.752,0,0,1-1.617-1.9L229.85,2.752a4.763,4.763,0,0,0-8.635,0L202.6,42.726a4.754,4.754,0,0,1-1.617,1.9l24.552,31.306Z",
    transform: "translate(-66.553 0)",
    fill: "#fff579"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48975",
    "data-name": "Path 48975",
    d: "M156.975,185.489a4.755,4.755,0,0,1,.1,2.211l-8.433,43.283a4.763,4.763,0,0,0,6.986,5.076l38.558-21.4a4.759,4.759,0,0,1,2.311-.6V170.172Z",
    transform: "translate(-35.437 -100.551)",
    fill: "#fff579"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48976",
    "data-name": "Path 48976",
    d: "M278.935,42.725,260.317,2.751A4.7,4.7,0,0,0,256,0V75.936h0l24.553-31.306a4.755,4.755,0,0,1-1.617-1.905Z",
    transform: "translate(-97.887 0)",
    fill: "#ffdd27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48977",
    "data-name": "Path 48977",
    d: "M236.762,450.672H158.947V421.3a4.935,4.935,0,0,1,4.651-5.177h68.514a4.935,4.935,0,0,1,4.651,5.177v29.368Z",
    transform: "translate(-38.876 -243.91)",
    fill: "#ffdd27"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29373",
    "data-name": "Group 29373",
    transform: "translate(102.486 201.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48978",
    "data-name": "Path 48978",
    d: "M226.315,495.387H125.749a6.712,6.712,0,0,1,0-13.387H226.315a6.712,6.712,0,0,1,0,13.387Z",
    transform: "translate(-119.539 -482)",
    fill: "#ffb139"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_48979",
    "data-name": "Path 48979",
    d: "M294.132,416.129H256v34.544h43.309V421.306A5.177,5.177,0,0,0,294.132,416.129Z",
    transform: "translate(-98.82 -243.91)",
    fill: "#ffb139"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48980",
    "data-name": "Path 48980",
    d: "M310.2,482H256v13.387h54.2a6.694,6.694,0,1,0,0-13.387Z",
    transform: "translate(-101.422 -280.387)",
    fill: "#ff7e4b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy1);
export default __webpack_public_path__ + "static/media/trophy_1.c994d121ac660b129af02eb6c0b0ead0.svg";
export { ForwardRef as ReactComponent };